import { render, staticRenderFns } from "./LegoViewTablero.vue?vue&type=template&id=98e6682c&scoped=true"
import script from "./LegoViewTablero.vue?vue&type=script&lang=js"
export * from "./LegoViewTablero.vue?vue&type=script&lang=js"
import style0 from "./LegoViewTablero.vue?vue&type=style&index=0&id=98e6682c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e6682c",
  null
  
)

export default component.exports